export const formatCompactNumber = (value, maxLength = 6) => {
  if (value == null || isNaN(value)) return '0';
  const abs = Math.abs(value);
  const trim = (num, decimals) => num.toFixed(decimals).replace(/\.0+$|(\.\d*[1-9])0+$/, '$1');
  if (abs < 1000) {
    return value.toLocaleString();
  }
  if (abs < 1000000) {
    for (let d = 1; d >= 0; d--) {
      const formatted = `${trim(value / 1000, d)}k`;
      if (formatted.length <= maxLength) return formatted;
    }
  }
  if (abs < 1000000000) {
    for (let d = 1; d >= 0; d--) {
      const formatted = `${trim(value / 1000000, d)}m`;
      if (formatted.length <= maxLength) return formatted;
    }
  }
  return `${trim(value / 1000000000, 1)}b`;
};
